export default __webpack_public_path__ + "static/media/owl-icon.851c6312.svg";